import React from 'react';
import PropTypes from 'prop-types';

import injectSheet from 'react-jss';

const { number, object, string } = PropTypes;

const styles = {};

const Bars = ({ classes, label, onItemClick, percent, value }) => {
  const percentage = `${percent}%`;
  return (
      <div style={{ marginBottom: '20px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
          <p style={{ fontSize: '14px', fontWeight: 600, margin: '0', padding: 0, textTransform: 'capitalize' }}>{`${label} rate`}</p>
          <p style={{ borderBottom: '2px dashed', color: 'rgb(255, 64, 129)', cursor: 'pointer', fontSize: '14px', fontWeight: 600, margin: '0 15px 0 0', padding: 0, textTransform: 'capitalize' }} onClick={() => onItemClick(label)}>{`${percentage}`}</p>
        </div>
          <div style={{ height: '25px', width: '100%', display: 'flex' }}>
            <svg style={{ height: '100%', width: '100%' }}>
              <rect style={{ fill: 'rgb(242, 242, 242)', width: '100%' }}></rect>
              <rect style={{ fill: 'rgb(0, 188, 212)', width: `${percentage}` }}>
                <animate attributeName="width" from="0" to={`${percentage}`} dur="0.5s" fill="freeze" />
              </rect>
            </svg>
          </div>
      </div>
    );
};

Bars.propTypes = {
  label: string,
  percent: number,
  total: number,
  style: object,
};

export default injectSheet(styles)(Bars);



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/widgets/bar.jsx